/* Wishlist launchpoint added to the header icon row (ThemeMate).
   Delegates click + count to Swym's own default launcher/badge rather than
   reimplementing either -- this only relocates the entry point visually. */
window.SwymCallbacks = window.SwymCallbacks || [];
window.SwymCallbacks.push(function () {
  var headerBadge = document.querySelector('.swymcs-header-badge');
  var headerLink = document.querySelector('.swymcs-header-wishlist-link');
  var swymBadge = document.querySelector('.swym-anchor-badge');
  if (!headerBadge || !headerLink || !swymBadge) return;

  function syncBadge() {
    var count = swymBadge.textContent;
    headerBadge.textContent = count;
    headerBadge.style.visibility = count && count !== '0' ? 'visible' : 'hidden';
  }

  syncBadge();

  var observer = new MutationObserver(syncBadge);
  observer.observe(swymBadge, { characterData: true, childList: true, subtree: true });

  headerLink.addEventListener('click', function (e) {
    e.preventDefault();
    var swymTrigger = document.getElementById('notepad-anchor-title');
    if (swymTrigger) swymTrigger.click();
  });
});
